import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-step-container',
  templateUrl: './step-container.component.html',
  styleUrls: ['./step-container.component.scss'],
})
export class StepContainerComponent {
  @Input() title: string = '';
  @Input() stepId: string = '';
  @Input() stepNumber?: number;
  @Input() isActive: boolean = false;
  @Input() isCompleted: boolean = false;
  @Input() stepDescription;
}
